<template>
  <div class="container__sm wizard-active-step py-3xl">
    <h2 v-if="dataSchema" class="page-title pb-2xl">
      <span v-text="localize('account_info')"></span>
      <span v-text="dataSchema.User.Email"></span>
    </h2>
    <p class="note required-fields-note">* {{localize('required_field')}}</p>
    <div v-if="dataSchema" class="flex align-start justify-center pt-xl pb-2xl">
      <div class="flex-child" v-if="!dataSchema.User.IsClinic">
        <h5 class="strong mb-m">
          {{localize('contact_information')}}
        </h5>
        <form-field
          :locale = "locale"
          v-bind:label="localize('first_name')"
          v-model="dataSchema.User.FirstName"
          req
          @validate-field="updateValidHash"
          :dirty="hasBeenSubmitted"
          :disabled="!isMcenter && !isDistributor"
        ></form-field>
        <form-field
          :locale = "locale"
          v-bind:label="localize('last_name')"
          v-model="dataSchema.User.LastName"
          :dirty="hasBeenSubmitted"
          @validate-field="updateValidHash"
          req
          :disabled="!isMcenter && !isDistributor"

        ></form-field>
        <div class="rel">
          <form-field
            :locale = "locale"
            field-type="phone"
            v-bind:label="localize('phone_num')"
            v-model="dataSchema.User.Phone"
            :dirty="hasBeenSubmitted"
            :err="!validateOnlyNumber(dataSchema.User.Phone)"
            :err-msg="errMsgs.numbersOnly"
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
        </div>
      </div>
      <div v-else class="flex-child">
        <div>
          <h5 class="strong">
            {{localize('clinic_info')}}
          </h5>
          <form-field
            :locale = "locale"
            v-bind:label="localize('clinic_name')"
            v-model="dataSchema.User.ClinicName"
            :dirty="hasBeenSubmitted"
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
          <form-field
          :locale = "locale"
            v-bind:label="localize('Branch')"
            v-model="dataSchema.User.ClinicBranch"
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
        </div>
        <div class="rel">
          <h5 class="strong">
            {{localize('dentist_list')}}
          </h5>
          <div class="over-scroll-300">
            <field-group
              :locale = "locale"
              class="align-center flex"
              v-for="(clinician, i) in dataSchema.ClinicSurgeons"
              :key="clinician.id"
              :group-index="i"
              :fields="clinicianFields"
              v-model="dataSchema.ClinicSurgeons[i]"
              label-all-fields
            >
              <i
                @click="clinician.active = false"
                class="cursor-pointer ml-s fal fa-power-off"
                :class="{ 'text-green-4': clinician.active }"
              ></i>
            </field-group>
          </div>
          <button @click="addDentist" class="btn btn-primary">
            <i class="fal fa-user-plus mr-xs"></i><span>Add Dentist</span>
          </button>
        </div>
      </div>

      <div class="flex-child">
        <h5 class="strong mb-m">
          {{localize('address')}}
        </h5>
        <div class="form-part--fields ratio-70-25">
          <form-field
            :locale = "locale"
            v-bind:label="localize('street')"
            v-model="dataSchema.User.Street"
            :dirty="hasBeenSubmitted"
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
          <form-field
            :locale = "locale"
            v-bind:label="localize('house_no')"
            v-model="dataSchema.User.StreetNo"
            :err="!validateOnlyNumber(dataSchema.User.StreetNo)"
            :err-msg="errMsgs.numbersOnly"
            :dirty="hasBeenSubmitted"
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
        </div>
        <div class="form-part--fields ratio-50-45">
          <form-field
            :locale = "locale"
            v-bind:label="localize('City')"
            v-model="dataSchema.User.City"
            :dirty="hasBeenSubmitted"
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
          <!-- <form-field
                  label="Country"
                  v-model="dataSchema.User.Country"
                  req
                ></form-field> -->
          <form-field
            :locale = "locale"
            v-if="countries && countries.length"
            field-type="select"
            :select-options="countries"
            select-placeholder="Country"
            v-model="dataSchema.User.Country"
            :dirty="hasBeenSubmitted"
            multi
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
          <form-field
            :locale = "locale"
            v-bind:label="localize('zip_code')"
            v-model="dataSchema.User.ZipCode"
            :dirty="hasBeenSubmitted"
            :err="!validateOnlyNumber(dataSchema.User.ZipCode)"
            :err-msg="errMsgs.numbersOnly"
            @validate-field="updateValidHash"
            req
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
          <form-field
            :locale = "locale"
            v-bind:label="localize('state')"
            v-model="dataSchema.User.state"
            :dirty="hasBeenSubmitted"
            :req="dataSchema.User.Country === 'usa'"
            @validate-field="updateValidHash"
          :disabled="!isMcenter && !isDistributor"

          ></form-field>
        </div>
      </div>
    </div>
    <div class="btn-bar">
      <button
          v-if="isMcenter && isDistributor"
      
       @click="submit" class="mt-s btn btn-primary right">
        <!-- <i class="fal fa-save mr-xs"></i> -->
        <span>Update Account</span>
      </button>
    </div>
  </div>
</template>
<script>
import { storage } from "@/utils";
import FormField from "@/components/FormField.vue";
import { mapGetters, mapState, mapActions } from "vuex";
export default {
  name: "edit-account",
  components: {
    // FieldGroup,
    FormField
  },
  data() {
    return {
      api: `${SERVER_API[ENV]}mflow/SignupInitData`,
      dataSchema: null,
      passConfirm: null,
      emailAvailable: "pending",
      accountVerified: false,
      verifyEmailScreen: false,
      // sendingToServer: false,
      // hasBeenSubmitted: false,
      // invalidFields: 0,
      // validHash: {},

      wizard: {
        totalSteps: 3,
        activeStep: 0,
        steps: [
          {label: "Personal Information",hasSteps: [0, 1]},
          {label: "Contact Information",hasSteps: [2]},
          {label: "Security Setup",hasSteps: [3]}
          ]
      },
      accountTypes: [
        {label: "I am a Dentist",value: 1},
        {label: "We are a Clinic",value: 2}
      ],
      clinicianFields: [
        {
          id: 1,
          _prop: "first_name",
          label: "First Name",
          type: "text",
          req: true
        },
        {
          id: 2,
          _prop: "last_name",
          label: "Last Name",
          type: "text",
          req: true
        }
      ],
      errMsgs: {
        // required: "This field is required",
        numbersOnly: "Numbers only please",
        noNumbers: "No Numbers allowed"
      }
    };
  },
  mounted() {
    let vm = this;

    //TRANSLATE LABLES
    vm.wizard.steps[0].label = vm.localize('personal_information');
    vm.wizard.steps[1].label = vm.localize('contact_information');
    vm.wizard.steps[2].label = vm.localize('security_setup');
    vm.accountTypes[0].label = vm.localize('i_am_a_dentist');
    vm.accountTypes[1].label = vm.localize('we_are_clinic');

    //vm.errMsgs.

    console.log("MOUNTED");
    this.$on("validate-field", function(id, valid) {
      console.log("YES", id, valid);
    });
    let api = `${SERVER_API[ENV]}mflow/UserInfo/${this.userID}`;

    fetch(api, {
      method: "get",
      mode: "cors",
      cache: "no-cache",
      headers: {
        "pragma": "no-cache",
        "cache-control": "No-Store",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*",
        t: this.userToken,
        u: this.userID
      }
    })
      .then(function(response) {
        return response.json();
      })
      .then(function(res) {
        console.log("response >>> ", res);
        vm.dataSchema = res;
      })
      .catch(err => err);
    // this.initDataSchema();
  },
  watch: {
    validationArr() {
      if (this.validatedFieldCount === this.validationArr.length) {
        console.log("validation ar >", this.validationArr);
        this.hasBeenSubmitted = true;
      }
    },
    "dataSchema.User": {
      deep: true,
      handler: _.debounce(function() {
        if (this.hasBeenSubmitted) {
          console.log("revalidate");
          this.$eventHub.emit("force-validate");

          // this.validateFields();
        }
      }, 300)
    }
  },
  methods: {
    ...mapActions(["initUser"]),
    addDentist() {
      let id = -1;
      this.dataSchema.ClinicSurgeons.push({
        id,
        first_name: "",
        last_name: ""
      });
    },
    validateOnlyString(_string) {
      return /^[a-z]+$/i.test(_string);
    },
    validateOnlyNumber(_string) {
      return /^[0-9]+$/i.test(_string);
    },
    submit() {
      console.log("SUBMIT ACCOUNT UPDATE");
      let submit_data = {
        User: this.dataSchema.User,
        ClinicSurgeons: this.dataSchema.ClinicSurgeons
      };
      if (this.dataSchema.User.isClinic) {
        submit_data.User.FirstName = "";
        submit_data.User.LastName = "";
      }
      // this.validateFields();
      // this.$eventHub.emit("force-validate");
      this.hasBeenSubmitted = true;
      this.$nextTick(function() {
        if (this.formIsValid) {
          console.log("FORM IS VALID");
          let body = JSON.stringify(submit_data);
          this.sendingToServer = true;
          let api = `${SERVER_API[ENV]}mflow/UserInfo`;
          let vm = this;

          fetch(api, {
            body,
            method: "post",
            mode: "cors",
            cache: "no-cache",
            headers: {
              "pragma": "no-cache",
              "cache-control": "No-Store",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": "*",

              t: this.userToken,
              u: this.userID
            }
          })
            .then(function(response) {
              console.log("RESPONSE >> ", response);
              return response.json();
            })
            .then(function(res) {
              console.log("edit accountres >", res);
              storage.set(`MFLOW__userData`, vm.dataSchema.User, localStorage);
              vm.initUser(vm.dataSchema.User);
              vm.$router.push("/");
              vm.$toasted.show("Your account has been updated", {
                position: "bottom-center",
                // iconPack: "fontawesome",
                type: "success",
                theme: "bubble",
                icon: {
                  name: "fal fa-check mr-xs"
                }
              });
            })
            .catch(err => err);
        } else {
          console.log("FORM IS INVALID< ", this.formIsValid);
        }
      });
    }
  },
  computed: {
    ...mapGetters(["userID", "userToken", "isMcenter", "isDistributor"]),
    ...mapState(["user","locale"]),
    wizardMsgScreen() {
      if (this.verifyEmailScreen) {
        return `
          <div class="container tcenter text-green-2 py-2xl"> 
          <i class='fal fa-paper-plane fa-3x'></i>
          <h3 class="text-green-3 my-xl">Your account has been created successfully.</h3>
          <h5>An email has been sent to you,<br> <strong>please click the verification link.</strong></h5>
          </div>
        `;
      }
      return null;
    },
    wizardLog() {
      if (this.sendingToServer) {
        return {
          type: "success",
          txt: "Creating your account... please wait.",
          icon: "preloader"
        };
      } else if (this.hasBeenSubmitted && !this.formIsValid) {
        return {
          type: "err",
          txt: `You have ${this.invalidFields} invalid field${
            this.invalidFields.length > 1 ? "s" : ""
          }, please check.`,
          icon: "fas fa-lightbulb-exclamation"
        };
      } else if (this.hasBeenSubmitted && this.formIsValid) {
        return {
          type: "success",
          txt: "Everything looks great!",
          icon: "fas fa-check-circle fa-2x"
        };
      }
      return null;
    },
    // formIsValid() {
    //   if (this.hasBeenSubmitted) {
    //     return this.invalidFields === 0;
    //   }
    //   return false;
    // },

    inAccountVerification() {
      return _.has(this.$route.query, "t");
    },
    isFinalStep() {
      return this.wizard.activeStep === this.wizard.totalSteps;
    },
    countries() {
      if (this.dataSchema.Countries) {
        return this.dataSchema.Countries.map(country => {
          return {
            label: country.Nicename,
            value: country.CountryID
          };
        });
      }
      return null;
    },
    validUserEmail() {
      return this.emailRx.test(this.dataSchema.User.Email);
    }
  }
};
</script>
<style lang="stylus" scoped>


.add-dentist
  position absolute
  bottom 0
  right 0
  transform translate(150%, -30px)
  cursor pointer
  color blue_brand
</style>

<style lang="stylus">
// SVG STYLES
.p-1,
.p-2
  fill none
  stroke #edf7f5
  stroke-linecap round
  stroke-miterlimit 10
.p-1
  stroke-width 4.8px
.p-2
  stroke-width 4.9px
.p-3
  fill #edf7f5
.pb-1
  fill none
  stroke #edf7f5
  stroke-linecap round
  stroke-miterlimit 10
  stroke-width 5.14px
</style>
